import type { EventPreferences } from "@/resources/notification/event-preferences.api";

export const DEFAULT_PREFS: EventPreferences = {
  signal: false,
  rank_change: false,
  landscape_complete: false,
  ab_test_results: false,
};
